<template>
  <div class="mtop">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户下注次数分布</span>
      </div>

      <el-form ref="queryForm2" :model="queryParams" :inline="true">
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery(0)"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery(0)"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery(0)">查询</el-button>
          <el-button icon="el-icon-download" :loading="loading" size="mini" @click="exportData(1)">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="100px"
        />
        <el-table-column
          prop="bet1"
          label="倍数1"
        />
        <el-table-column
          prop="bet2"
          label="倍数2"
        />
        <el-table-column
          prop="bet3"
          label="倍数3"
        />
        <el-table-column
          prop="bet4"
          label="倍数5"
        />
        <el-table-column
          prop="bet5"
          label="倍数10"
        />
        <el-table-column
          prop="bet6"
          label="倍数20"
        />
        <el-table-column
          prop="bet7"
          label="倍数50"
        />
        <el-table-column
          prop="bet8"
          label="倍数100"
        />
        <el-table-column
          prop="bet9"
          label="倍数200"
        />
        <el-table-column
          prop="bet10"
          label="倍数500"
        />
        <el-table-column
          prop="bet11"
          label="倍数1000"
        />
      </el-table>

      <el-card class="mtop">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </el-card>
  </div>
</template>

<script>
import { getUserBetStat } from '@/api/user/user_info'
import { dateStrTodate, getLastDates } from '@/utils'
import echarts from 'echarts'

export default {
  name: 'UserBetStat',
  data() {
    return {
      betMap: {
        1: '下注1',
        2: '下注2',
        3: '下注3',
        4: '下注5',
        5: '下注10',
        6: '下注20',
        7: '下注50',
        8: '下注100',
        9: '下注200',
        10: '下注500',
        11: '下注1000+'
      },
      tableData: [],
      coinTotal: 0,
      levelData: [],
      queryParams: {
        startDate: '',
        endDate: '',
        level: 0
      }
    }
  },
  created() {
    this.handleQuery(0)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    exportData() {
      this.handleQuery(-1)
    },
    handleQuery(level = 0) {
      this.queryParams.level = level
      if (this.queryParams.startDate === '') {
        this.queryParams.startDate = getLastDates(7)
      }

      if (this.queryParams.endDate === '') {
        this.queryParams.endDate = getLastDates(0)
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      this.loading = true
      getUserBetStat(this.queryParams).then(res => {
        this.loading = false
        if (this.queryParams.level === -1) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          return
        }
        this.tableData = res.data
        this.refresh()
      })
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '分布'
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            // rotate: 45 // 标签旋转45度
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh() {
      if (this.tableData.length <= 0) {
        return
      }

      const betData = {}

      for (let i = 1; i <= 11; i++) {
        betData[i] = []
      }

      for (const i in this.tableData) {
        const val = this.tableData[i]
        this.option.xAxis.data.push(dateStrTodate(val.date))
        for (const k in val) {
          const v = String(k).slice(3)
          if (betData[v] !== undefined) {
            betData[v].push(val[k])
          }
        }
      }

      for (const i in this.betMap) {
        const val = this.betMap[i]
        this.option.legend.data.push(val)
      }

      for (let i = 1; i <= 11; i++) {
        const temp = {
          name: this.betMap[i],
          data: betData[i],
          type: 'line',
          smooth: true
        }

        this.option.series.push(temp)
      }

      console.log('option', this.option)
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px
}
</style>
